const STORAGE_KEY = 'studyStats';

const getTodayKey = () => new Date().toISOString().slice(0, 10);

const getPreviousDayKey = (dateKey) => {
  const date = new Date(`${dateKey}T00:00:00`);
  date.setDate(date.getDate() - 1);
  return date.toISOString().slice(0, 10);
};

export const loadStudyStats = () => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (!saved) {
      return {
        currentStreak: 0,
        longestStreak: 0,
        totalAnswers: 0,
        studyDays: 0,
        lastStudyDate: null,
      };
    }

    return JSON.parse(saved);
  } catch (error) {
    console.warn('Error loading study stats:', error);
    return {
      currentStreak: 0,
      longestStreak: 0,
      totalAnswers: 0,
      studyDays: 0,
      lastStudyDate: null,
    };
  }
};

export const saveStudyStats = (stats) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(stats));
};

export const recordStudyActivity = (previousStats) => {
  const today = getTodayKey();
  const lastStudyDate = previousStats.lastStudyDate;
  const isSameDay = lastStudyDate === today;
  const isConsecutiveDay = lastStudyDate === getPreviousDayKey(today);

  const currentStreak = isSameDay
    ? previousStats.currentStreak
    : isConsecutiveDay
      ? previousStats.currentStreak + 1
      : 1;

  return {
    currentStreak,
    longestStreak: Math.max(previousStats.longestStreak, currentStreak),
    totalAnswers: previousStats.totalAnswers + 1,
    studyDays: isSameDay ? previousStats.studyDays : previousStats.studyDays + 1,
    lastStudyDate: today,
  };
};

export const formatLastReviewed = (cards) => {
  const timestamps = cards
    .map(card => card.lastReviewed)
    .filter(Boolean)
    .sort()
    .reverse();

  if (!timestamps.length) return 'Never';

  return new Date(timestamps[0]).toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
};
